'use client';
import { Tab } from '@/components/TabsBlock';
import ServicesSection from './ServicesSection';
import FilesSection from './FilesSection';
import { classes } from './utils';

export type OverviewTabProps = {
  isFetchingData: boolean;
  isFetchingFiles: boolean;
  name: string;
  label: string;
};

export default function OverviewTab({
  isFetchingData,
  isFetchingFiles,
  name,
  label,
}: OverviewTabProps) {
  return (
    <Tab className={classes.tab} name={name} label={label}>
      <ServicesSection isFetchingData={isFetchingData} />
      <FilesSection isFetchingData={isFetchingFiles} />
    </Tab>
  );
}
